import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Escritorio from "./components/Escritorio";
import AreasAtuacao from "./components/AreasAtuacao";
import ComoAtuamos from "./components/ComoAtuamos";
import Contato from "./components/Contato";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="font-body">
      <Navbar />
      <Hero />
      <Escritorio />
      <AreasAtuacao />
      <ComoAtuamos />
      <Contato />
      <Footer />

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/5547999300330"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center rounded-full bg-[#E3B24A] hover:bg-[#F2D27A] text-[#6E0C10] shadow-lg hover:scale-110 transition-all duration-300 cursor-pointer"
        aria-label="Falar pelo WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl" />
      </a>
    </main>
  );
}
